import { CopyIcon } from '@zorro/shared/assets';

import { CopyToClipboard } from '../../CopyToClipboard';

type CardCopyButtonProps = {
  text: string;
  ariaLabel: string;
};

const CardCopyButton = ({ text, ariaLabel }: CardCopyButtonProps) => (
  <CopyToClipboard text={text}>
    <button
      type="button"
      aria-label={ariaLabel}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <CopyIcon width={14} height={14} />
    </button>
  </CopyToClipboard>
);

export { CardCopyButton };
